import { Button, Form, Input, message, Select } from 'antd';
import { getSelectList, SelectList, SelectPayload } from 'api/dashboard';
//import { useLoginValidation } from "api/auth";
import { updateSourcePayload, updateSource } from 'api/master';
import { UserPayload } from 'api/profile';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type Props = {
  isAdmin: boolean;
  onSubmit: (values: updateSourcePayload) => Promise<void>;
};

const updatePayload: updateSourcePayload = {};
const initPartners: SelectList[] = [];
const inituser: UserPayload = {};

const UpdateSource = ({ onSubmit }: Props) => {
  const navigate = useNavigate();
  const { Option } = Select;
  const [filter, setFilter] = useState(updatePayload);
  const [form] = Form.useForm<updateSourcePayload>();
  const [statusList, setStatus] = useState(initPartners);
  const [_user, _setUser] = useState(inituser);
  const [_statusId, setStatusId] = useState(0);
  const [isSourceUpdate, setSourceUpdate] = useState(false);

  const location = useLocation();
  let state: any = location.state;
  console.log(state);

  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'LoanType',
    };
    getSelectList(statusPayload).then((res) => {
      setStatus(res.data);
    });
  }, []);


  const handleSubmit = useCallback(
    async (values: updateSourcePayload) => {
      debugger;
      setSourceUpdate(true);
      //values.userId = user.userId;
      values.Username = sessionStorage.getItem('user')?.toString;
      values.loanTypes = values.loanTypes?.toString();

      updateSource(values)
        .then((_res) => {
          debugger;
          if (_res.responseCode == '200' && _res.message == 'Source is updated!') {
            message.success('Source is updated Successfully!');
          }
          if (
            _res.responseCode == '200' &&
            (_res.message == 'Data Not Found!' || _res.message == 'Some Error Occured!')
          ) {
            message.warn('Data Not Found!');
          }
          if (_res.responseCode != '200') {
            message.warn('Some Error Occured!');
          }
        })
        .finally(() => {
          form.resetFields();
          setSourceUpdate(false);
          navigate('/master/source');
        });
    },
    [onSubmit, form]
  );

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = updatePayload;
    setFilter(updatedFilter);
  }

  const handleLoanId = (e: any) => {
    // debugger;
    // form.setFieldValue('statusId', e);
    // form.validateFields(['statusId']);
    setStatusId(Number(e));
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <div className="mid-container">
            <div className="submission-box">
              <h2>Edit Source</h2>
              <div className="submission-htmlForm">
                {/* <form action="/AvanseApp/Home/Filter" classNameName="standard-htmlForms" id="frmDashboard" method="post" /> */}
                <Form
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                  className="standard-forms"
                  initialValues={{
                    ['Username']: sessionStorage.getItem('user')?.toString(),
                    ['SourceApplicationName']: state.SourceApplicationName,
                    ['TypeofApplication']: state.TypeOfApplication,
                    ['SecretKey']: state.SecretKey,
                    ['loanTypes']: state.LoanTypes != null ? state.LoanTypes.split(',') : [],
                    ['SourceId']: state.SourceId,
                  }}
                >
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item
                          label={'Source Application Name :'}
                          name="SourceApplicationName"
                          className="fieldTitle"
                          style={{ marginBottom: '20px' }}
                        >
                          <Input placeholder={'Source Application Name'} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item
                          label={'Type of Application :'}
                          name="TypeofApplication"
                          className="fieldTitle"
                        >
                          <Select defaultValue={'Select'} size="large">
                            <Option value="Mobile">Mobile</Option>
                            <Option value="Web">Web</Option>
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Secret Key :'} name="SecretKey" className="fieldTitle">
                          <Input
                            placeholder={'Secret Key'}
                            style={{ border: '1px solid #dcdcdc', backgroundColor: '#f5f5f5' }}
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Source Id :'} name="SourceId" className="fieldTitle">
                          <Input
                            placeholder={'Source Id'}
                            style={{ border: '1px solid #dcdcdc', backgroundColor: '#f5f5f5' }}
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Success Url :'} name="successUrl" className="fieldTitle">
                          <Input placeholder={'Success Url'} />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-4 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Failure Url :'} name="failureUrl" className="fieldTitle">
                          <Input placeholder={'Failure Url'} />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-6">
                      <div className="input-box">
                        <Form.Item label={'Loan Type:'} name="loanTypes">
                          <Select
                            placeholder="Please select loan type"
                            size="large"
                            mode="multiple"
                            onSelect={handleLoanId}
                          // defaultValue={state.LoanTypes.split(',')}
                          >
                            {statusList.map((status) => (
                              <>
                                <Option value={status.SValue}>{status.SText}</Option>
                              </>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  <div className="row"></div>
                  <div className="payment-button">
                    <Button
                      className="proceed-btn"
                      id="btnSubmit"
                      htmlType="submit"
                      size="small"
                      disabled={isSourceUpdate ? true : false}
                    >
                      UPDATE
                    </Button>

                    <Button
                      id="btnClear"
                      className="proceed-btn"
                      size="small"
                      style={{ marginLeft: '10px' }}
                      onClick={handleReset}
                    >
                      CLEAR
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateSource;
